export default __webpack_public_path__ + "static/media/profilePic.a9136072.png";